
import EditComponent from "../../../components/mall_orders/Edit.vue";

export default {
  components: {
    EditComponent,
  },
};
